export const config = {
    tabList: [
        { name: '观点与优势一' },
        { name: '观点与优势二' },
        { name: '观点与优势三' }
    ],
    tabInfo: {
        '观点与优势一': {
            title: 'HRP的本质并不是一个软件项目，而是一个提升管理的服务项目，决定项目成功的主要因素是管理咨询服务与实施运维服务',
            tabContent: [
                {
                    info: '敬在团队具备管理咨询基因，背景是Oracle、SAP实施顾问，团队在医院HRP领域专注十余年，能给医院带来真正的管理提升，也更懂得如何推进HRP项目成功。',
                    des: '服务基因',
                    src: require('@/assets/images/about/img_company_opinion1.svg')
                },
                {
                    info: '敬在团队成员来自C9/985等国内外一流高 校，公司设立敬在学院，通过综合理论学习、 丰富的系统操作培训、严格的考核标准为行业 输出更多优秀实施顾问。优中择优的培养制度 下成长的敬在顾问具备卓越的项目推动、沟通 表达、客户服务能力。',
                    des: '优秀团队',
                    src: require('@/assets/images/about/img_company_opinion2.svg')
                },
                {
                    info: '敬在HRP产品基于全球先进技术框架，链接医院管理全场景，聚合医院管理数据，具有平台化、一体化、集团化、智能化、移动化、敏捷开发的特点。完整丰富的产品功能，先进灵活的产品设计，让代理商、实施顾问可以更简单、更高效的交付项目。',
                    des: '先进产品',
                    src: require('@/assets/images/about/img_company_opinion3.svg')
                },
                {
                    info: '敬在HRP支持国家卫健委医院智慧管理5级评测（当前最高标准），支持2022国家公立医院运营管理信息化功能指引标准与规范，并将持续跟进国家政策动向，持续适配国家政策要求。',
                    des: '国家评级',
                    src: require('@/assets/images/about/img_company_opinion4.svg')
                },
            ]
        },
        '观点与优势二': {
            title: '一个成功的HRP项目，比产品更重要的是实施服务',
            desc: '敬在为医院提供的不仅仅是一套HRP系统，更是管理提升与改革落地的咨询与实施服务。',
            tabContent: [
                {
                    name: '调研报告',
                    fold: true,
                    imgList: [
                        { src: require('@/assets/images/about/调研报告_01.svg'), },
                        { src: require('@/assets/images/about/调研报告_02.svg'), },
                        { src: require('@/assets/images/about/调研报告_03.svg'), },
                        { src: require('@/assets/images/about/调研报告_04.svg'), },
                    ]
                },
                {
                    name: '流程设计',
                    fold: false,
                    imgList: [
                        { src: require('@/assets/images/about/流程设计_01.svg'), },
                        { src: require('@/assets/images/about/流程设计_02.svg'), },
                        { src: require('@/assets/images/about/流程设计_03.svg'), },
                        { src: require('@/assets/images/about/流程设计_04.svg'), },
                    ]
                },
                {
                    name: '详细解决方案',
                    fold: false,
                    imgList: [
                        { src: require('@/assets/images/about/详细解决方案_01.svg'), },
                        { src: require('@/assets/images/about/详细解决方案_02.svg'), },
                        { src: require('@/assets/images/about/详细解决方案_03.svg'), },
                        { src: require('@/assets/images/about/详细解决方案_04.svg'), },
                    ]
                },
                {
                    name: '数据治理',
                    fold: false,
                    imgList: [
                        { src: require('@/assets/images/about/数据治理_01.svg'), },
                        { src: require('@/assets/images/about/数据治理_02.svg'), },
                        { src: require('@/assets/images/about/数据治理_03.svg'), },
                        { src: require('@/assets/images/about/数据治理_04.svg'), },
                    ]
                },
                {
                    name: '操作手册',
                    fold: false,
                    imgList: [
                        { src: require('@/assets/images/about/操作手册_01.svg'), },
                        { src: require('@/assets/images/about/操作手册_02.svg'), },
                        { src: require('@/assets/images/about/操作手册_03.svg'), },
                        { src: require('@/assets/images/about/操作手册_04.svg'), },
                    ]
                },
            ]
        },
        '观点与优势三': {
            title: '优秀、突出的实施服务能力，才是医院更需要的',
            desc: '敬在具备行业领先的项目实施能力和交付效率，每一个HRP项目，都会完成如下工作...',
            tabContent: [
                { num: '18+', desc: '走访调研科室18+个' },
                { num: '55+', desc: '访谈关键用户55+人' },
                { num: '50+', desc: '收集调研问卷50+份' },
                { num: '30+', desc: '出具详细调研报告30+份' },
                { num: '600+', desc: '沟通方案细节600+次' },
                { num: '15+', desc: '出具详细解决方案15+份' },
                { num: '80+', desc: '开展项目专项研讨会80+场' },
                { num: '400+', desc: '针对性设计业务流程图400+个' },
                { num: '10+', desc: '梳理对接系统接口10+个' },
                { num: '30万+', desc: '规范原始数据30万+行' },
                { num: '20+', desc: '开展岗位培训会议20+场' },
                { num: '60+', desc: '输出用户操作手册60+份' },
            ],
        }
    },
}
